import React from 'react';
import { format } from 'date-fns';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DateNavigator = ({ 
  currentDate, 
  onDateChange, 
  viewMode = 'month',
  onViewModeChange 
}) => {
  const navigateMonth = (direction) => {
    const newDate = new Date(currentDate);
    newDate?.setMonth(newDate?.getMonth() + direction);
    onDateChange(newDate);
  };

  const navigateYear = (direction) => {
    const newDate = new Date(currentDate);
    newDate?.setFullYear(newDate?.getFullYear() + direction);
    onDateChange(newDate);
  };

  const goToToday = () => {
    onDateChange(new Date());
  };

  const formatCurrentPeriod = () => {
    return format(currentDate, 'MMMM yyyy');
  };

  const quickDateOptions = [
    {
      label: 'This Month',
      action: () => onDateChange(new Date())
    },
    {
      label: 'Last Month',
      action: () => {
        const date = new Date();
        date?.setMonth(date?.getMonth() - 1);
        onDateChange(date);
      }
    },
    {
      label: 'Last 3 Months',
      action: () => {
        const date = new Date();
        date?.setMonth(date?.getMonth() - 3);
        onDateChange(date);
      }
    },
    {
      label: 'Last 6 Months',
      action: () => {
        const date = new Date();
        date?.setMonth(date?.getMonth() - 6);
        onDateChange(date);
      }
    }
  ];

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-4 sm:space-y-0 bg-card border border-border rounded-lg p-4">
      {/* Main Navigation */}
      <div className="flex items-center space-x-4">
        {/* Month Navigation */}
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigateMonth(-1)}
            iconName="ChevronLeft"
            className="w-8 h-8 p-0"
            title="Previous month"
          />
          
          <div className="flex items-center space-x-2 min-w-[200px] justify-center">
            <h2 className="text-lg font-semibold text-foreground">
              {formatCurrentPeriod()}
            </h2>
          </div>
          
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigateMonth(1)}
            iconName="ChevronRight"
            className="w-8 h-8 p-0"
            title="Next month"
          />
        </div>

        {/* Year Navigation */}
        <div className="flex items-center space-x-1 border-l border-border pl-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigateYear(-1)}
            iconName="ChevronsLeft"
            className="w-8 h-8 p-0"
            title="Previous year"
          />
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigateYear(1)}
            iconName="ChevronsRight"
            className="w-8 h-8 p-0"
            title="Next year"
          />
        </div>

        {/* Today Button */}
        <Button
          variant="outline"
          size="sm"
          onClick={goToToday}
          iconName="Calendar"
          iconPosition="left"
          className="ml-4"
        >
          Today
        </Button>
      </div>
      {/* Quick Date Options */}
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm text-muted-foreground mr-2">Quick:</span>
        {quickDateOptions?.map((option, index) => (
          <Button
            key={index}
            variant="ghost"
            size="sm"
            onClick={option?.action}
            className="text-xs"
          >
            {option?.label}
          </Button>
        ))}
      </div>
      {/* View Mode Toggle */}
      <div className="flex items-center space-x-2 border-l border-border pl-4">
        <span className="text-sm text-muted-foreground">View:</span>
        <div className="flex items-center bg-muted rounded-md p-1">
          <button
            onClick={() => onViewModeChange('month')}
            className={`
              px-3 py-1 text-xs font-medium rounded transition-all
              ${viewMode === 'month' ?'bg-background text-foreground shadow-sm' :'text-muted-foreground hover:text-foreground'
              }
            `}
          >
            <Icon name="Calendar" size={14} className="mr-1 inline" />
            Month
          </button>
          <button
            onClick={() => onViewModeChange('timeline')}
            className={`
              px-3 py-1 text-xs font-medium rounded transition-all
              ${viewMode === 'timeline' ?'bg-background text-foreground shadow-sm' :'text-muted-foreground hover:text-foreground'
              }
            `}
          >
            <Icon name="List" size={14} className="mr-1 inline" />
            Timeline
          </button>
        </div>
      </div>
    </div>
  );
};

export default DateNavigator;
